import React from "react"
import classnames from "classnames"
import { withPrefix } from "gatsby"

const VideoDisplayer = ({ videoSrc, poster, isYouTube }) => {
  return (
    <div
      className={classnames({
        "video-displayer": true,
        "video-displayer--youtube": isYouTube,
      })}
    >
      {isYouTube ? (
        <iframe width="420" height="345" src={videoSrc}></iframe>
      ) : (
        <video poster={withPrefix(poster)} controls>
          <source type="video/mp4" src={videoSrc}></source>
          <source type="video/ogg" src={videoSrc}></source>
          <source type="video/webm" src={videoSrc}></source>
        </video>
      )}
    </div>
  )
}

export default VideoDisplayer
